import { Typography } from '@mui/material';
import React from 'react';

type OfferItemProps = {
  image?: boolean;
  imgSrc?: string;
  imgAlt?: string;
  title: string;
  description: string;
};

const OfferItem: React.FC<OfferItemProps> = ({
  imgSrc,
  imgAlt,
  title,
  description,
  image = true,
}) => {
  return (
    <div className="space-y-6">
      {image && <img src={imgSrc} alt={imgAlt} className="size-14 md:size-20" />}
      <div className="flex flex-col gap-y-2">
        <Typography variant="h5" color="textPrimary" className="uppercase">
          {title}
        </Typography>
        <Typography
          variant="s1"
          color="textSecondary"
          component="p"
          className="leading-6 md:leading-7"
        >
          {description}
        </Typography>
      </div>
    </div>
  );
};

export default OfferItem;
